module.exports = __webpack_public_path__ + "static/media/cancel.121116a2.svg";